<template>
    <Field
            :labelFor="name"
            :title="title"
            :errorMessage="errorMessage"
            :description="description"
            :helpText="helpText"
            :required="required"
    >

        <template v-slot:input>
            <v-select
                    :name="name"
                    :id="name"
                    v-model="model"
                    :disabled="disabled"
                    :options="optionsFormated"
                    :value="value"
                    :reduce="value => value.code"
                    :clearable="false"
            >
                <div slot="no-options"><T>Geen opties gevonden.</T></div>
            </v-select>
        </template>

    </Field>
</template>

<script>
    import FieldMixin from '../../mixins/FieldMixin'

    export default {
        name: "FieldSelect",
        mixins: [
            FieldMixin
        ],
        data: function(){
            return {
                optionsFormated: [],
            };
        },
        methods: {
            formatOptions: function() {
                let self = this;
                _.each(self.selectOptions,function(item,key) {
                    // if we have option groups loop over them
                    if(_.isObject(item)) {
                        _.each(item,function(childItem,key) {
                            self.optionsFormated.push(self.formatOption(childItem,key));
                        });
                    } else {
                        self.optionsFormated.push(self.formatOption(item,key));
                    }
                });
            },
            formatOption: function(item,key) {
                return {
                    label: item,
                    code: key,
                };
            }
        },
        created: function() {
            this.formatOptions();
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/form/components/fields/FieldSelect.vue